import { render, staticRenderFns } from "./Monitor2Config.vue?vue&type=template&id=21e4a0a4"
import script from "./Monitor2Config.vue?vue&type=script&lang=js"
export * from "./Monitor2Config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports